import { Coordinate } from 'ol/coordinate';
import { Map } from 'ol';
import { Projection, transform } from 'ol/proj';

import { Extent } from 'ol/extent';

interface LatLng {
  lat: number;
  lng: number;
}

interface Size {
  width: number;
  height: number;
}

interface MapDimensions {
  center: LatLng;
  zoomLevel: number;
  size: Size;
  extent: Extent;
  southWest: LatLng;
  northEast: LatLng;
}

export function getDimensionsFromMap(
  map: Map,
  mapProjection: Projection | string,
  userProjection: Projection | string
): MapDimensions | null {
  const viewObject = map.getView();
  const viewCenter = viewObject.getCenter();
  const mapSize = map.getSize();
  if (viewCenter == null || mapSize == null) {
    return null;
  }
  const center = transform(viewCenter, mapProjection, userProjection);
  const extent = viewObject.calculateExtent(mapSize);
  const northEast = transform(
    [extent[2], extent[3]],
    mapProjection,
    userProjection
  );
  const southWest = transform(
    [extent[0], extent[1]],
    mapProjection,
    userProjection
  );

  return {
    center: mapCoordinateToLatLng(center),
    size: { width: mapSize[0], height: mapSize[1] },
    zoomLevel: viewObject.getZoom() ?? 0,
    extent,
    northEast: mapCoordinateToLatLng(northEast),
    southWest: mapCoordinateToLatLng(southWest),
  };
}

const mapCoordinateToLatLng = (coordinate: Coordinate) => ({
  lat: coordinate[1],
  lng: coordinate[0],
});
